import { useSyncExternalStore } from 'react';

const cache = new Map<string, MediaQueryList>();

function mql(query: string): MediaQueryList {
  let m = cache.get(query);
  if (!m) {
    m = matchMedia(query);
    cache.set(query, m);
  }
  return m;
}

/** Live result of a media query. */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = mql(query);
      m.addEventListener('change', cb);
      return () => m.removeEventListener('change', cb);
    },
    () => mql(query).matches,
    () => false,
  );
}

export const DESKTOP = '(min-width: 1100px)';
